import dayjs from "dayjs";
import { transformSDateToString } from "@/shared/utils";
import { DATE_FORMAT } from "@/shared/constants";
import type { BirthdaySDate } from "@/services/api/entities/person/types";

export const getAge = (birthdaySDate?: BirthdaySDate) => {
  if (!birthdaySDate?.year || !birthdaySDate?.month || !birthdaySDate?.day) return;

  const birthday = dayjs(transformSDateToString(birthdaySDate), DATE_FORMAT);
  const today = dayjs();

  return today.diff(birthday, "year");
};
